import React from 'react';
import PdfViewer from './PdfViewer';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';

const Documentatie = (props) => {

		return <PdfViewer pdfUrl={props.page.pdfUrl}/>

}

export default HeaderFooterHOC(Documentatie);


